import { defaultFetch, defaultFetchDownload, defaultFetchWithMeta } from './baseApi';

// get and CRUD statements by project id

type StatementType = {
	id: number;
	sequence: string | null;
	name: string;
	date: string;
	amount: number;
	state: string;
	sent: boolean;
	approved: boolean;
	note: string | null;
	monthsReportingEndDate: number;
	monthsReportingStartDate: number;
	monthsApprovedDate: number;
	monthsSentDate: number;

	project: {
		id: number;
		name: string;
		description: string | null;
		manager: string | null;
		cup: string;
		network: boolean;
		note: string | null;
		amount: number | null;
		cuts: string | null;
		applicant: string | null;
		hidden: boolean;
		sco: boolean;
		company: {
			id: number;
			name: string;
			vat: string;
			address: string;
			pec: string;
			attorney: string | null;
			code: string;
			oecompanysize: string | null;
			sizeCode: string | null;
			legalRepresentative: string;
			powerOfAttorney: number;
			payrollMgmtModule: boolean;
			aiEnabled: boolean;
			createdBy: number;
			updatedBy: number;
			hasModulePartnership: boolean;
		};
		notice: {
			id: number;
			name: string;
			objectives: string | null;
			disbursement: string | null;
			timeframe: string | null;
			compounding: string | null;
			dnsh: number;
			call: string;
			fund: {
				id: number;
				code: string;
				name: string;
				description: string;
				createdBy: number | null;
				updatedBy: number | null;
			};
			instrument: {
				id: number;
				name: string;
				managingAuthority: string;
				createdBy: number;
				updatedBy: number;
			};
			institution: {
				id: number;
				code: string;
				name: string;
				managingSystem: string;
				updatedAt: string | null;
				createdBy: number;
				updatedBy: number;
			};
			fundId: number;
			instrumentId: number;
			questionsetId: number;
			publishedAt: string;
			expiresAt: string;
			institutionId: number;
			institutionCode: string;
			admissibleCosts: string | null;
			advancePaymentPercentage: string | null;
			changeManagement: string | null;
			managingSystem: string | null;
			digitalTagging: number;
			environmentalTagging: number;
			genderEquality: number;
			reportableEmployeeDays: string | null;
			createdBy: number;
			updatedBy: number;
			questionSet: {
				id: number;
				name: string;
				description: string;
				used: boolean;
				default: boolean;
				legacyType: string;
				createdBy: number;
				updatedBy: string | null;
			};
		};
		oeManager: string | null;
		location: string | null;
		companyId: number;
		noticeId: number;
		streamConfigurationType: string;
		durationInMonths: number;
		oeManagerId: number | null;
		forecastStartDate: string;
		forecastEndDate: string;
		startDate: string | null;
		endDate: string | null;
		networkNote: string;
		aiEnabled: false;
		locationCode: string | null;
		finalAmount: string | null;
		assignedAmount: string | null;
		totalAdmissibleAmount: string | null;
		totalApprovedAmount: string | null;
		indirectCostsPerc: number;
		payrollMgmtModule: false;
		reportableEmployeeDays: string | null;
		vatRate: string | null;
		localProjectCode: string | null;
		projectCodeStamp: string | null;
		applicantEmail: string | null;
		dnshMitigationActivityNumber: string | null;
		dnshAdaptationActivityNumber: string | null;
		dnshAdaptationActivity: string | null;
		dnshAdaptationSector: string | null;
		dnshMitigationActivity: string | null;
		dnshMitigationSector: string | null;
		dnshClimateAdaptation: false;
		dnshClimateMitigation: false;
		dnshElement: string | null;
		createdBy: number;
		updatedBy: number;
		hasPartnership: boolean;
	};
	oestatementtype: {
		code: string;
		name: string;
		description: string;
	};
	projectId: number;
	statementTypeCode: string;
	reportingStartDate: string | null;
	reportingEndDate: string | null;
	cashedIn: boolean;
	cashedInDate: string | null;
	cashedInAmount: number;
	requestedAmount: number;
	approvedAmount: number;
	indirectCost: number;
	indirectInvoiceCost: number;
	helpPercentageIntensity: number;
	contextAndObjectives: string | null;
	projectPolicyRelevance: string | null;
	expectedOutcomes: string | null;
	workPerformedAndResults: string | null;
	approvedDate: string | null;
	sentDate: string | null;
	createdBy: number;
	updatedBy: number;
};

export const getStatementsByProjectId = async (projectId: string, state?: 'DRAFT' | 'VALIDATED') => {
	let url = `/v0/projects/${projectId}/statements?statement_type_code=PR`;
	if (state) url += `&state=${state}`;

	return defaultFetch<StatementType[]>(url);
};

export const createStatementByProjectId = async (
	projectId: string,
	params: {
		statementTypeCode: 'PR';
		reportingStartDate: string;
		reportingEndDate: string;
	},
) => {
	const url = `/v0/projects/${projectId}/statements`;
	return defaultFetch<StatementType>(url, {
		method: 'POST',
		body: JSON.stringify(params),
	});
};
export const updateStatementByProjectIdAndStatementId = async (
	projectId: string,
	statementId: number,
	params: {
		statementTypeCode: 'PR';
		reportingStartDate: string;
		reportingEndDate: string;
		note: string;
		contextAndObjectives: string;
		workPerformedAndResults: string;
		expectedOutcomes: string;
		projectPolicyRelevance: string;
	},
) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}`;
	return defaultFetch<StatementType>(url, {
		method: 'PUT',
		body: JSON.stringify(params),
	});
};
export const updateStatementStatusByProjectIdAndStatementId = async (
	projectId: string,
	statementId: number,
	params: {
		statementTypeCode: 'PR';
		sent: boolean;
		amount: number;
		sentDate: string;
		approved: boolean;
		approvedAmount: number;
		approvedDate: string;
		cashedIn: boolean;
		cashedInAmount: number;
		cashedInDate: string;
	},
) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}`;
	return defaultFetch<StatementType>(url, {
		method: 'PUT',
		body: JSON.stringify(params),
	});
};
export const validateStatementByProjectIdAndStatementId = async (projectId: string, statementId: number) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}`;
	return defaultFetch<StatementType>(url, {
		method: 'PUT',
		body: JSON.stringify({ state: 'VALIDATED', amount: 0 }),
	});
};
export const deleteStatementByProjectIdAndStatementId = async (projectId: string, statementId: number) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}`;
	return defaultFetch(url, {
		method: 'DELETE',
	});
};

// get invoices or timesheets by project id and statement id
type InvoiceType = {
	id: number;
	amount: number;
	number: string;
	name: string;
	position: number;
	checked: number;
	advertising: string | null;
	otplant: string | null;
	invoice: string | null;
	dueDate: string | null;
	quotaNumber: number;
	invoiceId: number;
	rpCode: string;
	supplierName: string;
	supplierCode: string;
	generalExpenses: number;
	finalQuantity: number;
	toSettle: number;
	assetName: string | null;
	assetCode: string | null;
	beneficiaryId: number;
	beneficiaryName: string;
	streamName: string;
	streamId: string;
	expenseItemName: string;
	noticeExpenseItemName: string;
};

type TimesheetType = {
	number: string;
	year: number;
	month: number;
	day: number;
	category: string;
	wbe: string | null;
	name: string;
	checked: number;
	timesheetDetailId: number;
	timesheetId: number;
	projectStreamId: number;
	streamName: string;
	streamId: number;
	serialNumber: string;
	orderNumber: string | null;
	totalCost: number;
	beneficiaryId: number;
	beneficiaryName: string;
	expenseItemName: string;
};

type MetaType = {
	total: number;
	currentPage: number;
	perPage: number;
};

// utility function to create url with search params
const createInvoiceOrTimesheetUrl = (url: string, searchParams: { currentPage?: number; perPage?: number; searchTerm?: string }) => {
	const params: string[] = [];

	if (searchParams.currentPage) params.push(`page=${searchParams.currentPage}`);
	if (searchParams.perPage) params.push(`perPage=${searchParams.perPage}`);
	if (searchParams.searchTerm) params.push(`term=${searchParams.searchTerm}`);

	if (params.length > 0) {
		url += `?${params.join('&')}`;
	}
	return url;
};

export const getInvoicesByProjectIdAndStatementId = async (
	projectId: string,
	statementId: number,
	searchParams: {
		currentPage?: number;
		perPage?: number;
		searchTerm?: string;
	},
) => {
	const url = createInvoiceOrTimesheetUrl(`/v0/projects/${projectId}/statements/${statementId}/invoices`, searchParams);

	return defaultFetchWithMeta<InvoiceType[], MetaType>(url);
};
export const getTimesheetsByProjectIdAndStatementId = async (
	projectId: string,
	statementId: number,
	searchParams: {
		currentPage?: number;
		perPage?: number;
		searchTerm?: string;
	},
) => {
	const url = createInvoiceOrTimesheetUrl(`/v0/projects/${projectId}/statements/${statementId}/timesheets`, searchParams);

	return defaultFetchWithMeta<TimesheetType[], MetaType>(url);
};

// get indirect costs by project id and statement id
export type IndirectCostType = {
	id: number;
	amount: number;
	statementId: number;
	projectexpenseitemId: number;
	companyOwnerId: number;
	geShare: number;
	geAmount: number;
	createdBy: number;
	updatedBy: number;
	expenseItem: {
		id: number;
		name: string;
		position: number;
		projectNoticeExpenseItemId: number;
		humanResource: boolean;
		generalExpenses: boolean;
		geShare: number;

		createdBy: number;
		updatedBy: number;
		noticeExpenseItem: {
			id: number;
			name: string;
			position: number;
			project: {
				id: number;
				name: string;
				description: string;
				manager: string | null;
				cup: string;
				network: boolean;
				note: string;
				amount: null;
				cuts: null;
				applicant: null;
				hidden: boolean;
				sco: boolean;
				company: {
					id: number;
					name: string;
					vat: string;
					address: string | null;
					pec: string | null;
					attorney: string | null;
					code: string;
					sizeCode: string;
					legalRepresentative: null;
					powerOfAttorney: number;
					payrollMgmtModule: boolean;
					aiEnabled: boolean;
					createdBy: number;
					updatedBy: number;
					hasModulePartnership: boolean;
				};
				companyId: number;
				noticeId: number;
				streamConfigurationType: string;
				durationInMonths: number;
				oeManagerId: number | null;
				forecastStartDate: string;
				forecastEndDate: string;
				startDate: string | null;
				endDate: string | null;
				networkNote: string;
				aiEnabled: boolean;
				locationCode: string | null;
				finalAmount: null;
				assignedAmount: null;
				totalAdmissibleAmount: null;
				totalApprovedAmount: null;
				indirectCostsPerc: number;
				payrollMgmtModule: boolean;
				reportableEmployeeDays: null;
				vatRate: null;
				localProjectCode: string | null;
				projectCodeStamp: string | null;
				applicantEmail: string | null;
				dnshMitigationActivityNumber: null;
				dnshAdaptationActivityNumber: null;
				dnshAdaptationActivity: null;
				dnshAdaptationSector: null;
				dnshMitigationActivity: null;
				dnshMitigationSector: null;
				dnshClimateAdaptation: boolean;
				dnshClimateMitigation: boolean;
				dnshElement: null;
				createdBy: number;
				updatedBy: number;
				hasPartnership: boolean;
			};
			projectId: number;
			noticeExpenseItemId: number;
			createdBy: number;
			updatedBy: number;
		};
	};
	companyOwner: {
		id: number;
		name: string;
		vat: string;
		address: null;
		pec: null;
		attorney: null;
		code: string;
		sizeCode: string;
		legalRepresentative: null;
		powerOfAttorney: number;
		payrollMgmtModule: boolean;
		aiEnabled: boolean;
		createdBy: number;
		updatedBy: number;
		hasModulePartnership: boolean;
	};
};
export const getIndirectCostsByProjectIdAndStatementId = async (projectId: string, statementId: number) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}/expenseiteminstances`;

	return defaultFetch<{
		statementGe: {
			[ownerId: number]: {
				items: IndirectCostType[];
				indirectCosts: number;
				totalCosts: number;
			};
		};
	}>(url);
};

// pick or unpick invoices or timesheets by project id and statement id
export const pickAllInvoicesByProjectIdAndStatementId = async (projectId: string, statementId: number, invoiceIds: number[]) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}/invoices/pickall`;

	const body = JSON.stringify({ quotaIds: invoiceIds });
	return defaultFetch(url, { method: 'POST', body });
};
export const unpickAllInvoicesByProjectIdAndStatementId = async (projectId: string, statementId: number, invoiceIds: number[]) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}/invoices/unpickall`;

	const body = JSON.stringify({ quotaIds: invoiceIds });
	return defaultFetch(url, { method: 'POST', body });
};

export const pickAllTimesheetsByProjectIdAndStatementId = async (projectId: string, statementId: number, timesheetIds: number[]) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}/timesheets/pickall`;

	const body = JSON.stringify({ timesheetDetailIds: timesheetIds });
	return defaultFetch(url, { method: 'POST', body });
};
export const unpickAllTimesheetsByProjectIdAndStatementId = async (projectId: string, statementId: number, timesheetIds: number[]) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}/timesheets/unpickall`;

	const body = JSON.stringify({ timesheetDetailIds: timesheetIds });
	return defaultFetch(url, { method: 'POST', body });
};

export type TotalType = {
	requestedAmount: number;
	total: number;
	totalEligibles: number;
	totalToSettle: number;
};

export const getStatementAmountsByProjectIdAndStatementId = async (projectId: string, statementId: number) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}/total`;

	return defaultFetch<TotalType>(url);
};

// get questions to settle by project id and statement id and quota id
type AnswerType = {
	id: number;
	yes: boolean;
	no: boolean;
	na: boolean;
	nd: boolean;
	rec: boolean;
	documents: null;
	ai: boolean;
	note: null;
	question: {
		code: string;
		number: number;
		questions: string;
		procedure: null;
		objective: string;
		note: null;
		exportable: boolean;
		entityCode: string;
		entityType: string;
		sectionNumber: number;
		sectionName: string;
		questionsFormatted: null;
		codeExportable: null;
		createdAt: null;
		updatedAt: null;
	};
	checklistId: number;
	questionCode: string;
	noteCode: null;
	createdAt: string;
	updatedAt: string;
	createdBy: null;
	updatedBy: number;
	laravelThroughKey: number;
};

export type QuestionToSettleType = {
	answers: AnswerType[];
	quotaId: number;
	invoiceId: number;
	entityType: string;
	entityId: number;
	checklistId: number;
	projectId: number;
};

export const getQuestionsToSettleByProjectIdAndStatementIdAndQuotaId = async (projectId: string, statementId: number, quotaId: number) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}/invoices/settle/quota/${quotaId}`;

	return defaultFetch<QuestionToSettleType[]>(url);
};

export const settleChecklistAnswers = async (questionsToSettle: { id: number; note: string }[]) => {
	const url = '/v0/checklistanswers/settle';

	const body = JSON.stringify({ answers: questionsToSettle });

	return defaultFetch(url, {
		method: 'POST',
		body,
	});
};

export const settleFilteredCheckListAnswers = async (
	projectId: string,
	statementId: number,
	selectedIds: number[],
	searchParams: {
		rpCode?: string;
		type?: string;
		rc?: string[];
	},
) => {
	let url = `/v0/projects/${projectId}/statements/${statementId}/invoices/settle`;

	if (searchParams.rpCode && searchParams.type) {
		if (searchParams.rc.length > 0) {
			const rcs = searchParams.rc.map((rc) => `rc[]=${rc}`);
			url += `?rpCode=${searchParams.rpCode}&type=${searchParams.type}&${rcs.join('&')}`;
		} else {
			url += `?rpCode=${searchParams.rpCode}&type=${searchParams.type}`;
		}
		// url += `?rpCode=${searchParams.rpCode}&type=${searchParams.type}`;
	} else if (searchParams.rpCode && !searchParams.type) {
		url += `?rpCode=${searchParams.rpCode}`;
	} else if (!searchParams.rpCode && searchParams.type) {
		if (searchParams.rc.length > 0) {
			const rcs = searchParams.rc.map((rc) => `rc[]=${rc}`);
			url += `?type=${searchParams.type}&${rcs.join('&')}`;
		} else {
			url += `?type=${searchParams.type}`;
		}
	}

	const body = JSON.stringify({ quotaIds: selectedIds });

	return defaultFetch(url, {
		method: 'POST',
		body,
	});
};

// get invoices to analyze in Record tab by project id and statement id
export const getInvoicesToAnalyzeByProjectIdAndStatementId = async (
	projectId: string,
	statementId: number,
	searchParams: {
		rpCode?: string;
		type?: string;
		rc?: string[];
	},
) => {
	let url = `/v0/projects/${projectId}/statements/${statementId}/invoices?analysis=1`;

	if (searchParams.rpCode) {
		url += `&rpCode=${searchParams.rpCode}`;
	}
	if (searchParams.type) {
		url += `&type=${searchParams.type}`;
		if (searchParams.rc.length > 0) {
			const rcs = searchParams.rc.map((rc) => `rc[]=${rc}`);
			url += `&${rcs.join('&')}`;
		}
	}

	return defaultFetch<InvoiceType[]>(url);
};

// get checklist options
type ChecklistType = {
	code: string;
	title: string;
};
export const getChecklistOptionsByEntityType = async (projectId: string, statementId: number, entityType: string) => {
	const url = `/v0/projects/${projectId}/statements/${statementId}/analysissettlefilter?type=${entityType}`;
	return defaultFetch<ChecklistType[]>(url);
};

// download invoices
export const downloadInvoicesOrTimesheetsByProjectIdAndStatementId = async (params: {
	projectId: string;
	statementId: number;
	docType: 'invoices' | 'timesheets';
}) => {
	const url = `/v0/projects/${params.projectId}/statements/${params.statementId}/${params.docType}/print`;

	return defaultFetchDownload(url);
};

export type TotalsType = {
	total: number;
	totalRequestedAmount: number;
	statements: {
		total: number;
		statementId: number;
	}[];
};

export const getTotalsByProjectId = async (projectId: string, state: 'DRAFT' | 'VALIDATED') => {
	const url = `/v0/projects/${projectId}/statements/totals?state=${state}`;
	return defaultFetch<TotalsType>(url);
};
